import { render, staticRenderFns } from "./editionRed.vue?vue&type=template&id=6e786c8c&scoped=true&"
import script from "./editionRed.vue?vue&type=script&lang=js&"
export * from "./editionRed.vue?vue&type=script&lang=js&"
import style0 from "./editionRed.vue?vue&type=style&index=0&id=6e786c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e786c8c",
  null
  
)

export default component.exports